export { default as SendOtp } from './send-otp';
export { default as VerifyOtp } from './verify-otp';
export { default as ChangePassword } from './change-password';
export { default as ForgotMobile } from './forgot-mobile';
export { default as ForgotEmail } from './forgot-email';
